import { ArrowRight } from 'lucide-react'
import { BRAND, DOC_BLUSH } from '@/constants/brand'
import { cn } from '@/utils/cn'

export type TransferContextCardProps = {
  fromLabel: string
  fromCode: string
  toLabel?: string
  toCode?: string
  refDoc?: string
  className?: string
}

function Row({
  label,
  value,
  sub,
}: {
  label: string
  value: string
  sub?: string
}) {
  return (
    <div className="mb-2 flex items-start gap-2.5 last:mb-0">
      <span className="w-14 shrink-0 pt-0.5 text-[10px] font-extrabold uppercase text-muted-foreground">
        {label}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[13px] font-extrabold text-foreground">{value}</span>
        {sub ? (
          <span className="mt-0.5 block truncate text-[10.5px] font-semibold text-muted-foreground">
            {sub}
          </span>
        ) : null}
      </span>
    </div>
  )
}

export function TransferContextCard({
  fromLabel,
  fromCode,
  toLabel,
  toCode,
  refDoc,
  className,
}: TransferContextCardProps) {
  return (
    <div
      className={cn('rfid-confirm-card', className)}
      style={{
        backgroundColor: DOC_BLUSH,
        borderColor: `${BRAND}44`,
      }}
    >
      <div
        className="mb-2.5 text-[11px] font-black uppercase tracking-wide"
        style={{ color: BRAND }}
      >
        Transfer context
      </div>

      <Row label="From" value={fromLabel} sub={fromCode} />

      {toLabel ? (
        <>
          <div className="mb-2 flex justify-center">
            <ArrowRight size={16} color={BRAND} strokeWidth={2.5} />
          </div>
          <Row label="To" value={toLabel} sub={toCode} />
        </>
      ) : null}

      {refDoc ? <Row label="Base doc" value={refDoc} /> : null}
    </div>
  )
}
